<template>
  <div id="skeleton">
    <div id="nav" class="flex flex-between">
      <div class="flex">
        <div class="menu-tiger" @click="tigerMenu">
          <svg-icon icon-class="menu" class="menu-icon" />
        </div>
        <div class="logo">
          <router-link to="/normal/dashboard">
            <img src="../../assets/logo35.png" />
          </router-link>
        </div>
      </div>
      <div class="flex-grow">
        <slot name="nav" />
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div id="menu" v-show="fix">
        <slot name="menu" />
        <!-- <div class="copy">
          简赢 &copy; 版权所有
        </div> -->
      </div>
    </transition>
    <div id="main" ref="main" :style="{ marginLeft: fix ? '218px' : '0' }">
      <slot />
    </div>
  </div>
</template>

<script>
import Store from "store";

export default {
  name: "NormalLayout",
  props: {
    menuFix: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fix: this.menuFix,
    };
  },
  mounted() {
    // 从本地缓存中获得 菜单栏 是打开是关闭
    if (Store.get("menuFix") == undefined) {
      this.fix = true;
      return;
    }
    this.fix = Store.get("menuFix");
  },
  methods: {
    tigerMenu() {
      this.fix = !this.fix;
      this.$refs.main.style.marginLeft = this.fix ? "218px" : "0";
      Store.set("menuFix", this.fix);
    },
  },
};
</script>

<style scoped>
#skeleton {
  min-width: 1200px;
}
#nav {
  min-width: 1200px;
  height: 50px;
  box-shadow: 0 2px 4px 0 #dddddd;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 10;
  background: #fff;
}
.menu-tiger {
  height: 50px;
  width: 50px;
  background: #444;
  text-align: center;
  line-height: 50px;
}
.menu-icon {
  font-size: 20px;
}
#menu {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  margin-top: 50px;
  /* margin-bottom: 30px; */
  width: 215px;
  overflow-y: auto;
  background: #fff;
  padding-top: 10px;
  border-right: solid #f4f4f4 3px;
  z-index: 5;
}
.copy {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #f9f9f9;
  height: 30px;
  width: 215px;
  border-right: solid #f4f4f4 3px;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  color: #999;
}
#main {
  margin-top: 65px;
}
.logo {
  padding: 7px 20px;
  width: 110px;
}
</style>